import {
  React,
  useRef, 
  useState,
  useEffect
} from 'react';

import {
  Box,
  Button,
  Card,
  CardContent,
  Container,
  Grid,
  Select,
  Slider, 
  Tab,
  Typography ,
  MenuItem,
  InputLabel,
  FormControl,
} from '@mui/material';


function getTempertureColor(temp)
{
    let blue = Math.round(255 - temp);
    let red = Math.round(temp);
    red = red+100;
;   let green = 0;

    return "rgb("+red+", 0, "+blue+")"
}

const TemperatureDisplay = ({title, temp}) =>{
	const myRef = useRef(null);

    const [width, setWidth] =  useState();
    
     useEffect(() => {
          const element = myRef.current;
          const rect = element.getBoundingClientRect();
          
          setWidth(rect.width);
          
          const updateWindowSize = () => {
          	  
               const element = myRef.current;
               const rect = element.getBoundingClientRect();
               setWidth(rect.width);
          };

         window.addEventListener('resize', updateWindowSize);
         return () => {
           window.removeEventListener('resize', updateWindowSize);
         };

     }, []);

 return (
 	<Grid

	    style={{border:"1px solid #cccccc", padding:"2px", margin:"1px"}}
        container
        spacing={1}
    >
    	<Grid 
         	item
     		lg={12}
            md={12}
            xl={12}
            xs={12}
        >
            <InputLabel shrink>{title}</InputLabel>
        </Grid>
        <Grid
          	ref={myRef}
            item
            xl={4}
            lg={4}
            md={4}
            xs={4}
        >
        	<svg width="100%" height="210" version="1.1">
				<rect x="5%"  y="0" width="40%" height="215" rx="0" ry="0" fill="lightgray" />
				<rect x="10%"  y={5+200-temp} width="30%" height={temp} rx="0" ry="0" fill={getTempertureColor(temp)} />
    		    
    		    <line x1="5%" y1="5" x2="50%" y2="5" stroke="black" stroke-width="2" />
    			<text x="55%" y="12" font-size="16" font-family="Arial" fill="black">200</text>

    			<line x1="5%" y1="25" x2="50%" y2="25" stroke="black" stroke-width="2" />
    			<text x="55%" y="30" font-size="16" font-family="Arial" fill="black">180</text>

    			<line x1="5%" y1="45" x2="50%" y2="45" stroke="black" stroke-width="2" />
    			<text x="55%" y="50" font-size="16" font-family="Arial" fill="black">160</text>

    			<line x1="5%" y1="65" x2="50%" y2="65" stroke="black" stroke-width="2" />
    			<text x="55%" y="70" font-size="16" font-family="Arial" fill="black">140</text>

    			<line x1="5%" y1="85" x2="50%" y2="85" stroke="black" stroke-width="2" />
    			<text x="55%" y="90" font-size="16" font-family="Arial" fill="black">120</text>

    			<line x1="5%" y1="105" x2="50%" y2="105" stroke="black" stroke-width="2" />
    			<text x="55%" y="110" font-size="16" font-family="Arial" fill="black">100</text>

    			<line x1="5%" y1="125" x2="50%" y2="125" stroke="black" stroke-width="2" />
    			<text x="55%" y="130" font-size="16" font-family="Arial" fill="black">80</text>

    			<line x1="5%" y1="145" x2="50%" y2="145" stroke="black" stroke-width="2" />
    			<text x="55%" y="150" font-size="16" font-family="Arial" fill="black">60</text>

    			<line x1="5%" y1="165" x2="50%" y2="165" stroke="black" stroke-width="2" />
    			<text x="55%" y="170" font-size="16" font-family="Arial" fill="black">40</text>

    			<line x1="5%" y1="185" x2="50%" y2="185" stroke="black" stroke-width="2" />
    			<text x="55%" y="190" font-size="16" font-family="Arial" fill="black">20</text>

    			<line x1="5%" y1="205" x2="50%" y2="205" stroke="black" stroke-width="2" />
    			<text x="55%" y="210" font-size="16" font-family="Arial" fill="black">0</text>
			</svg>
        </Grid>
        <Grid
            item
            xl={8}
            lg={8}
            md={8}
            xs={8}
        >
        	<h2 style={{textAlign:"center",fontSize:width/3+"px", fontFamily:"sans-serif", fontWeight:"lighter"}}>{title}:</h2>
        	<h1 style={{textAlign:"center",fontSize: width/2.5+"px", fontFamily:"sans-serif", fontWeight:"lighter"}}>{temp}&deg;C</h1>
        </Grid>
    </Grid>
	);
};

TemperatureDisplay.propTypes = {
};

export default TemperatureDisplay;